module.exports = __webpack_public_path__ + "img/209.7851aa96.png";